import { PayorResponsibilityEnum } from '../../../../../constants';
import {
  FORTA_BLUE,
  FORTA_ERROR,
  FORTA_ORANGE,
  FORTA_SUCCESS,
  FORTA_YELLOW,
} from '../../../../../utils/colors';
import {
  PA_EXPIRY_CRITICAL_DAYS,
  PA_EXPIRY_WARNING_DAYS,
  PLAN_BAY_OPTIONS,
  TREATMENT_PLAN_V3_STATUS,
} from '../constants';
import { hasPlanStatus } from '../utils';

import type {
  Bays,
  ITPPriorAuthorizations,
  ITreatmentPlan,
  ITreatmentPlanStatusIdByLabel,
} from '../../../../../utils/types';
import type { PageHeaderIndicator } from './types';

export function getPlanStatusIndicator(
  plan: ITreatmentPlan | null,
  tpStatusIdByLabel: ITreatmentPlanStatusIdByLabel,
): PageHeaderIndicator | null {
  if (hasPlanStatus(plan, tpStatusIdByLabel, [TREATMENT_PLAN_V3_STATUS.STARTED])) {
    return { label: 'Started', dotColor: FORTA_BLUE.bright };
  }
  if (hasPlanStatus(plan, tpStatusIdByLabel, [TREATMENT_PLAN_V3_STATUS.EDITING])) {
    return { label: 'Editing', dotColor: FORTA_YELLOW };
  }
  if (hasPlanStatus(plan, tpStatusIdByLabel, [TREATMENT_PLAN_V3_STATUS.COMPLETED])) {
    return { label: 'Completed', dotColor: FORTA_SUCCESS };
  }
  if (hasPlanStatus(plan, tpStatusIdByLabel, [TREATMENT_PLAN_V3_STATUS.READ_ONLY])) {
    return { label: 'Historical TP', dotColor: FORTA_BLUE.dark };
  }
  return null;
}

export function getPlanBayLabel(bay: Bays | undefined): string {
  return PLAN_BAY_OPTIONS.find((option) => option.bay === bay)?.label ?? '';
}

export function getPaDaysUntilExpiry(
  priorAuthorizations: ITPPriorAuthorizations[],
  planId: number | undefined,
): number | null {
  if (planId === undefined) return null;
  const planAuthorizations = priorAuthorizations.filter(
    (authorization) => authorization.active_treatment_plan_id === planId,
  );
  const authorization =
    planAuthorizations.find(
      (item) => item.payor_responsibility === PayorResponsibilityEnum.PRIMARY,
    ) ??
    planAuthorizations.find(
      (item) => item.payor_responsibility === PayorResponsibilityEnum.SECONDARY,
    );
  return authorization?.days_until_expiry ?? null;
}

export function getPaExpiryIndicator(days: number | null): PageHeaderIndicator | null {
  if (days === null) return null;
  let dotColor = FORTA_SUCCESS;
  if (days <= PA_EXPIRY_CRITICAL_DAYS) {
    dotColor = FORTA_ERROR;
  } else if (days <= PA_EXPIRY_WARNING_DAYS) {
    dotColor = FORTA_ORANGE;
  }
  if (days <= 0) return { label: 'Expired', dotColor };
  return { label: `${days} ${days === 1 ? 'day' : 'days'}`, dotColor };
}
